import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import styles from './ButtonLink.module.scss';
import { ICustomAttributes, TChildren } from '../../typings/common';
import { ButtonLinkAppearance } from './types';

interface Props {
  children: TChildren;
  appearance?: ButtonLinkAppearance;
  href?: string;
  locationState?: Record<string, unknown>;
  external?: boolean;
  replace?: boolean;
  size?: 'inherit' | 'base';
  underline?: 'always' | 'never';
  isDisabled?: boolean;
  attributes?: ICustomAttributes;
  onClick?: () => void;
  className?: string;
}

const ButtonLink: React.FC<Props> = ({
  attributes,
  children,
  appearance = ButtonLinkAppearance.MAIN_LIGHT,
  href,
  locationState,
  external = false,
  replace = false,
  size = 'base',
  underline = 'never',
  isDisabled = false,
  onClick,
  className = '',
}) => {
  const classes = classNames(
    styles.link,
    styles[appearance],
    styles[`size-${size}`],
    styles[`underline-${underline}`],
    isDisabled ? styles.disabled : '',
    className
  );

  if (href) {
    if (external) {
      return (
        <a
          href={href}
          className={classes}
          onClick={onClick}
          {...attributes}>
          {children}
        </a>
      );
    }
    return (
      <Link
        to={href}
        replace={replace}
        state={locationState}
        className={classes}
        onClick={onClick}
        {...attributes}>
        {children}
      </Link>
    );
  }

  return (
    <button
      type='button'
      className={classes}
      onClick={onClick}
      disabled={isDisabled}
      {...attributes}>
      {children}
    </button>
  );
};

export default ButtonLink;
